import React, { Component } from 'react';
import { SecondsToMMSS } from '../../../common/constant';
class ReverseTimer extends Component {
  constructor(props) {
    super(props);
    this.state = {
      timerStart: true,
      seconds: props.seconds ? props.seconds : 150,
    };
    this.timer = 0;
  }
  mounted = false;
  stopTimer = () => {
    const { timerStart } = this.state;
    if (this.mounted)
      if (timerStart === true) {
        this.setState({
          timerStart: false,
        });
        clearInterval(this.timer);
      } else {
        this.setState({
          timerStart: true,
        });
        this.timer = setInterval(this.countDown, 1000);
      }
  };
  componentWillUnmount() {
    this.mounted = false;
  }

  componentDidMount() {
    this.mounted = true;
    this.timer = setInterval(this.countDown, 1000);
  }

  countDown = () => {
    if (this.mounted)
      if (this.state.seconds > 0)
        this.setState({
          seconds: this.state.seconds - 1,
        });
      else clearInterval(this.timer);
  };

  componentDidUpdate(prev) {
    if (prev.stopTimer !== this.props.stopTimer) {
      this.stopTimer();
    }
  }
  render() {
    const { timerStart, seconds } = this.state;
    const currentTime = SecondsToMMSS(seconds);
    const { stopTimer } = this.props;
    // console.log('stopTimer=====>', stopTimer);
    return (
      <div>
        <div className='timer_outer h-min-content py-1'>
          <div>
            <h4>{'Estimated Time Left'}</h4>
            <span className={`timer_box ${seconds <= 10 ? 'blink text-danger' : ''}`}>
              {currentTime}
            </span>
          </div>
        </div>
        <button
          type='button'
          className={`tooltip_wrap hover-pad-same
                          ${
                            timerStart
                              ? 'icon-control-pause pause_btn'
                              : 'pause_btn icon-control-play'
                          }`}
          disabled={stopTimer}
          onClick={() => this.stopTimer()}
        >
          <div className='tootip_box'>{'Save and Take a break'}</div>
        </button>
      </div>
    );
  }
}
export default ReverseTimer;



// WEBPACK FOOTER //
// ./src/views/CFA3/Cfa3EssayQuestions/ReverseTimer.jsx